//Const SELECTOR = '.survey-with-customer-validation'
const SELECTOR = '.survey-holidays'

/**
 * IG-1546 Temporary place for getting static survey data. Actuall solution
 * exist in branch IG-1512 that mean that it will be ready to use here
 * after merge new ReservationPage branch.
 */
function getStaticSurveyData () {
  const root = document.querySelector(SELECTOR)
  return window.grecos && window.grecos.data ? window.grecos.data[root.id] : {}
}

export async function init () {
  if (document.querySelector(SELECTOR)) {
    const SurveyWithCustomerValidation = (await import(/* webpackChunkName: "Survey" */ '@/components/Survey')).default
    document.querySelectorAll(SELECTOR).forEach(el => {
      new SurveyWithCustomerValidation({ el, propsData: { staticData: getStaticSurveyData() } })
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/survey.js